import React, { useEffect, useRef, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Grid,
  Button,
  InputAdornment,
  Typography,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

import {
  getAccountReachageDetails,
  getAllEmployeeList,
  getAllPerice,
} from "./appoinmentDashboardApi";
import { getData } from "./smbAccountRechargeCustomApiHandler";
import {
  convertDateToCustomFormat,
  getFirstDateOfMonth,
  getStartOfMonth,
} from "../../utils/commonUtils";
import AppoinmentDashboardCard from "./AppoinmentDashboardCard";
import { DatePicker } from "@mui/x-date-pickers";
import DatePickerComponent from "../../common/curstomDatePicker";
import FormModal from "./FormModal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import CardPayment from "../payment/cardPayment";
import FormModalT from "./FormDatatt";
import FormModalTtt from "./FormDatattt";

export default function ExpenceEmp({ gridSize }) {
  const [open, setOpen] = useState(false);
  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);
  const [date, setDate] = useState(getStartOfMonth());
  const [SelectedStartDate, setSelectedStartDate] = useState(
    getFirstDateOfMonth()
  );
  const [modalData, setModalData] = useState(null);
  const [value, setValue] = useState("Unassigned");
  const [valuet, setValuet] = useState("Assigned");
  const [data, setData] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [cardValue, setCardValue] = useState(null);
  const [list, setList] = useState([]);
  const datePickerRef = useRef();

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const cardKet = {
    educationalDetail: [
      { key: "employeeId", label: "Employee ID" },
      { key: "employeeName", label: "Employee Name", color: "#bb4a9b" },
      { key: "companyName", label: "Company Name", color: "#bb4a9b" },
      { key: "location", label: "Location" },
      { key: "fromDate", label: "From Date" },
      { key: "toDate", label: "To Date" },
      { key: "designation", label: "Designation" },
      { key: "primarySkillSet", label: "Primary Skill Set" },
      { key: "specialization", label: "Specialization" },
      { key: "otherSkillSet", label: "Other Skill Set" },
    ],
    incentrive: [
      { key: "incentiveName", label: "Incentive Name" },
      { key: "minimumValue", label: "Minimum Value" },
      { key: "maximumValue", label: "Maximum Value" },
      { key: "percentage", label: "percentage" },
    ],
    Deductions: [
      { key: "componentName", label: "Component Name" },
      { key: "amount", label: "Amount" },
      { key: "percentage", label: "Percentage" },
    ],
  };

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const handleChange = (event, newValue) => setValue(newValue);
  const handleChanget = (event, newValue) => setValuet(newValue);

  useEffect(() => {
    getAllEmployeeList((res) => {
      setData(res?.list);
    });
  }, []);

  useEffect(() => {
    console.log("search ", search, "cardValue", cardValue);
  }, [search, cardValue]);

  useEffect(() => {
    if (search?.id) {
      getAllPerice({ employeeId: search.id }, (data) => {
        setList(data?.data?.data?.list || []);
      });
    }
  }, [search?.id]);

  useEffect(() => {
    getAllPerice(
      {
        // employeeId:search?.id
      },
      (data) => {
        console.log("list  data?.data?.data ", data);

        setList(data?.data?.data?.list);
      }
    );
  }, []);
  useEffect(() => {
    console.log("modalData parent", modalData);
  }, [modalData]);

  useEffect(() => {
    if (!open) {
      setModalData({});
    }
  }, [open]);

  const filteredList = search?.name
    ? list.filter((ele) =>
        ele?.employeeName?.toLowerCase()?.includes(search?.name?.toLowerCase())
      )
    : list;

  return (
    <Box
      px={2}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            borderRadius: "5px",
            color: "#01008B",
            textAlign: "left",
            marginBottom: "20px",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            fontSize={{ xs: "12px", sm: "13px", md: "18px" }}
          >
            Employee Experience Details
          </Typography>
        </Grid>

        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} sm={7} md={8}>
            <TextField
              value={search?.name || ""}
              placeholder="Search"
              size="small"
              fullWidth
              variant="outlined"
              onClick={() => setSearchModal(true)}
              sx={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "6px",
                // color: "#555555",
                "& .MuiOutlinedInput-root": {
                  border: "none",
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#555555",
                  opacity: 6,
                  fontWeight: 500,
                  cursor: "pointer",
                },
              }}
              InputProps={{
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    {search?.name ? (
                      <CloseIcon
                        sx={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSearchvalue("");
                          setCardValue(null);
                        }}
                      />
                    ) : (
                      <SearchIcon color="primary" sx={{ cursor: "pointer" }} />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <PoprchModal
              cardValue={cardValue}
              setCardValue={(data) => {
                setSearchvalue(data);
                setCardValue(data);
              }}
              callback={() => {}}
              searchModal={searchModal}
              setSearchModal={setSearchModal}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={2} sx={{ padding: "0px" }}>
            {!gridSize && (
              <Button
                fullWidth
                onClick={() => setOpen(true)}
                sx={{
                  textTransform: "capitalize",
                  width: { xs: "100%", sm: "auto" },
                  whiteSpace: "nowrap",
                  zIndex: "0",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                size="medium"
                color="primary"
                variant="contained"
                aria-label="add"
              >
                Add Experience Details
                <AddIcon sx={{ marginLeft: "6px" }} />
              </Button>
            )}
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            p: { xs: "1px", sm: "10px" },
            mt: 2,
            background: "white",
            borderRadius: "12px",
            overflowX: "auto",
          }}
        >
          <Box sx={{ minWidth: "600px" }}>
            <Grid container>
              {/* Header */}
              <Grid item xs={12}>
                <Grid
                  container
                  sx={{
                    borderBottom: "1.5px solid black",
                    padding: "10px",
                  }}
                >
                  <Grid item xs={2}>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        textAlign: "center",
                        fontWeight: 500,
                        color: "#01008B",
                      }}
                    >
                      Employee ID
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        textAlign: "center",
                        fontWeight: 500,
                        color: "#01008B",
                      }}
                    >
                      Employee Name
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        textAlign: "center",
                        fontWeight: 500,
                        color: "#01008B",
                      }}
                    >
                      Company Name
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        textAlign: "center",
                        fontWeight: 500,
                        color: "#01008B",
                      }}
                    >
                      Location
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        textAlign: "center",
                        fontWeight: 500,
                        color: "#01008B",
                      }}
                    >
                      Designation
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* Data Rows */}
              <Grid
                item
                xs={12}
                sx={{
                  height: "60vh",
                  overflowY: "auto",
                  marginTop: "10px",
                  padding: "10px",
                }}
              >
                {filteredList.map((ele, index) => {
                  if (search && search?.employeeId !== ele?.employeeId)
                    return null;

                  return (
                    <Grid
                      container
                      key={index}
                      onClick={() => {
                        setModalData(ele);
                        setOpen(true);
                      }}
                      sx={{
                        p: "8px 0",
                        borderBottom: "1px solid #eee",
                        alignItems: "center",
                        backgroundColor: "#E8E8FF",
                        borderRadius: "8px",
                        mb: 1,
                        cursor: "pointer",
                      }}
                    >
                      <Grid
                        item
                        xs={2}
                        sx={{ pl: { xs: 1, sm: 2, md: 3, lg: 6 } }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontWeight: "500",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          {ele?.employeeId || "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        sx={{ pl: { xs: 3, sm: 2, md: 5, lg: 10 } }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontWeight: "500",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          {ele?.employeeName || "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        sx={{ pl: { xs: 4, sm: 3, md: 5, lg: 11 } }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontWeight: "500",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          {ele?.companyName || "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        sx={{ pl: { xs: 4, sm: 3, md: 5, lg: 9 } }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontWeight: "500",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          {ele?.location || "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        sx={{ pl: { xs: 3, sm: 2, md: 4, lg: 7 } }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontWeight: "500",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          {ele?.designation || "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <FormModalTtt
          open={open}
          setOpen={setOpen}
          getAll={() => {
            // getAllEmployeeList((res) => {
            //   setData(res?.list);
            // });
            getAllPerice(
              {
                employeeId: search?.id,
              },
              (data) => {
                setList(data?.data?.data?.list);
              }
            );
          }}
          modalData={modalData}
        />
      </Grid>
    </Box>
  );
}
